import { Button } from '~/components/ui/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '~/components/ui/form';
import { Input } from '~/components/ui/input';

import type { UseFormReturn } from 'react-hook-form';

type Props = {
  form: UseFormReturn<{
    email: string;
    password: string;
  }>;
  onNext: () => void;
};

export const EmailForm = ({ form, onNext }: Props) => {
  const handleNext = async () => {
    const isValid = await form.trigger('email');
    if (isValid) {
      onNext();
    }
  };

  return (
    <Form {...form}>
      <form className="flex w-full flex-col gap-4">
        <p className="text-neutral-350 mb-2 text-center text-xl font-medium tracking-tight">
          What's your email address?
        </p>
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormControl>
                <Input
                  {...field}
                  autoFocus
                  autoComplete="email"
                  placeholder="Enter your work e-mail..."
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      handleNext();
                      e.preventDefault();
                    }
                  }}
                  className="bg-primary-500 border-primary-450 hover:bg-primary-550 hover:border-primary-400 focus:bg-primary-550 focus:shadow-solid active:border-neutral-250 focus:border-primary-450 shadow-primary-550 h-14 text-neutral-300 placeholder:text-neutral-400 hover:shadow active:shadow-none"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <Button
          type="button"
          className="bg-primary-500 border-primary-450 h-14 w-full text-neutral-300"
          onClick={handleNext}
          disabled={!form.getValues('email')}
        >
          Next
        </Button>
      </form>
    </Form>
  );
};
